import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|History|Audit|Detail';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPCandidateHistoryAuditItemsLoc =
	| 'SPCandidateHistoryAuditItemsTitle'
	| 'SPCandidateHistoryAuditItemsTableCrcatName'
	| 'SPCandidateHistoryAuditItemsTableCertActiveDate'
	| 'SPCandidateHistoryAuditItemsTableCertExpireDate'
	| 'SPCandidateHistoryAuditItemsTableState'
	| 'SPCandidateHistoryAuditItemsTablePoints'
	| 'SPCandidateHistoryAuditItemsTableDocDataLen'
	| 'SPCandidateHistoryAuditItemsTableDocLanguage'
	| 'SPCandidateHistoryAuditItemsRemove'
	| 'SPCandidateHistoryAuditItemsRemoveConfirmation'
	| 'SPCandidateHistoryAuditItemsTableCraInvalid'
	| 'SPCandidateHistoryAuditItemsTableCraValid'
	| 'SPCandidateHistoryAuditItemsTableCraPending'
	| 'SPCandidateHistoryAuditItemsView';

export const spCandidateHistoryAuditItemsLocs: LocDefs<SPCandidateHistoryAuditItemsLoc> = {
	SPCandidateHistoryAuditItemsTitle: {
		defaultValue: 'Audit Items',
		description: 'Section title for the candidate history audit detail items section.',
		displayPath: `${dpRoot}|Items Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableCrcatName: {
		defaultValue: 'Requirements',
		description: 'Table column header for the requirements.',
		displayPath: `${dpRoot}|Requirements`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableCertActiveDate: {
		defaultValue: 'Active Date',
		description: 'Table column header for the certification active date.',
		displayPath: `${dpRoot}|Active Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableCertExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Table column header for the certification expire date.',
		displayPath: `${dpRoot}|Expire Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableState: {
		defaultValue: 'State',
		description: 'Table column header for the certification state.',
		displayPath: `${dpRoot}|State`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTablePoints: {
		defaultValue: 'Points',
		description: 'Table column header for the certification points.',
		displayPath: `${dpRoot}|Points`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableDocDataLen: {
		defaultValue: 'Doc Data Len',
		description: 'Table column header for the certification doc data len.',
		displayPath: `${dpRoot}|Doc Data Len`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableDocLanguage: {
		defaultValue: 'Doc Language',
		description: 'Table column header for the certification doc language.',
		displayPath: `${dpRoot}|Doc Language`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsRemove: {
		defaultValue: 'Remove',
		description: 'Button label for the remove action.',
		displayPath: `${dpRoot}|Remove`,
		displayType: 'Button',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsRemoveConfirmation: {
		defaultValue: 'Are you sure you want to remove the selected items?',
		description: 'Confirmation message for the remove action.',
		displayPath: `${dpRoot}|Remove Confirmation`,
		displayType: 'Content',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableCraInvalid: {
		defaultValue: 'Invalid',
		description: 'Value when the audit item is invalid.',
		displayPath: `${dpRoot}|Invalid`,
		displayType: 'Content',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableCraValid: {
		defaultValue: 'Valid',
		description: 'Value when the audit item is valid.',
		displayPath: `${dpRoot}|Valid`,
		displayType: 'Content',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsTableCraPending: {
		defaultValue: 'Pending',
		description: 'Value when the audit item is pending.',
		displayPath: `${dpRoot}|Pending`,
		displayType: 'Content',
		...sharedProps,
	},
	SPCandidateHistoryAuditItemsView: {
		defaultValue: 'View',
		description: 'Button label for the view action.',
		displayPath: `${dpRoot}|View`,
		displayType: 'Button',
		...sharedProps,
	},
};

export const spCandidateHistoryAuditItemsLocKeys = MapLocKeys<SPCandidateHistoryAuditItemsLoc>(
	spCandidateHistoryAuditItemsLocs
);
export type SPCandidateHistoryAuditItemsLocKeys = typeof spCandidateHistoryAuditItemsLocKeys;
export const invalidStatusLocs = {
	invalid: spCandidateHistoryAuditItemsLocKeys.SPCandidateHistoryAuditItemsTableCraInvalid,
	valid: spCandidateHistoryAuditItemsLocKeys.SPCandidateHistoryAuditItemsTableCraValid,
	pending: spCandidateHistoryAuditItemsLocKeys.SPCandidateHistoryAuditItemsTableCraPending,
};
